import { ApplicationConfig, ErrorHandler } from "@angular/core";
import * as Sentry from "@sentry/angular";

import { routes } from "./app.routes";
import { provideCore } from "./core/core";
import { provideServiceWorker } from "@angular/service-worker";
import { environment } from "../environments/environment";

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    provideServiceWorker("ngsw-worker.js", { enabled: environment.production }),
    provideCore({ routes }),
  ],
};
